import React from 'react';
import { useLocation } from 'react-router-dom';

import Route from '@components/routes/Route';
import Platforms from '@pages/Onboarding/Dropshipping/Platforms';
import Gateways from '@pages/Onboarding/Dropshipping/Gateways';
import Marketing from '@pages/Onboarding/Dropshipping/Marketing';
import CheckoutFee from '@pages/Onboarding/Dropshipping/CheckoutFee';
import AlmostDone from '@pages/Onboarding/Dropshipping/AlmostDone';
import Integrations from '@pages/Onboarding/Dropshipping/Integrations';

import { DropshippingProvider } from '@helpers/hooks/pages/onboarding/useDropshipping';

const Dropshipping: React.FC = () => {
  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [location]);

  return (
    <DropshippingProvider>
      <Route
        isPrivate
        exact
        path="/onboarding/:storeAliasId/dropshipping/integrations"
        component={Integrations}
      />
      <Route
        isPrivate
        exact
        path="/onboarding/:storeAliasId/dropshipping/integrations/platforms"
        component={Platforms}
      />
      <Route
        isPrivate
        exact
        path="/onboarding/:storeAliasId/dropshipping/integrations/gateways"
        component={Gateways}
      />
      <Route
        isPrivate
        exact
        path="/onboarding/:storeAliasId/dropshipping/integrations/marketing"
        component={Marketing}
      />
      <Route
        isPrivate
        exact
        path="/onboarding/:storeAliasId/dropshipping/integrations/integration-finished"
        component={AlmostDone}
      />
      <Route
        isPrivate
        exact
        path="/onboarding/:storeAliasId/dropshipping/checkout-fee"
        component={CheckoutFee}
      />
    </DropshippingProvider>
  );
};

export default React.memo(Dropshipping);
